import { Component, Output, EventEmitter, Input, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-button-spinner',
  templateUrl: './button-spinner.component.html',
  styleUrls: [ './button-spinner.component.scss' ]
})

export class ButtonSpinnerComponent implements OnInit, OnDestroy {
  @Input() public label: string;
  @Input() public isPaymentContext: boolean;
  @Input() public disable: boolean;
  @Input() public ticketWinHistory: boolean;
  @Input() public reenableConfirmButton = new EventEmitter<boolean>(false);
  @Output() public onClick = new EventEmitter<any>();
  @ViewChild('confirmButton') public confirmButton: ElementRef;

  public showSpinner = false;

  private buttonSubscription: Subscription;

  constructor()
  {}

  public ngOnInit(): void
  {
    this.reenableClickedButton();
  }

  public onButtonClick(event) 
  {
    this.confirmButton.nativeElement.setAttribute('disabled', 'true')
    this.showSpinner = true;
    this.onClick.emit();
  }

  public reenableClickedButton(): void
  {
    this.buttonSubscription = this.reenableConfirmButton.subscribe((enabled: boolean) => {
        if (!enabled) {
          this.confirmButton.nativeElement.setAttribute('disabled', 'true');
        } else {
          this.confirmButton.nativeElement.removeAttribute('disabled');
        }
        this.showSpinner = false;
    });
  }

  public ngOnDestroy(): void
  {
    this.buttonSubscription.unsubscribe();
  }
}
